function Header(){
    return(
    <div className="">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
            <div className="text-center">
                <div className="text-center">
                    <h2 className="text-3xl tracking-tight font-gilroy-bold text-gray-900 sm:text-4xl dark:text-white">Articulos y Ensayos</h2>
                    <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4 font-gilroy-medium">
                        Domina la programacion, ciencia de datos, hacking etico y big data!
                    </p>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Header